// extracted by mini-css-extract-plugin
export default {"container":"dK-z","topReviewHeading":"eK-z","criticalReview":"fK-z","favorableReview":"gK-z","vsSeparator":"hK-z"};